import { render, staticRenderFns } from "./RateProgressBar.vue?vue&type=template&id=0370b8b6&scoped=true"
import script from "./RateProgressBar.vue?vue&type=script&lang=js"
export * from "./RateProgressBar.vue?vue&type=script&lang=js"
import style0 from "./RateProgressBar.vue?vue&type=style&index=0&id=0370b8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0370b8b6",
  null
  
)

export default component.exports